import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function About() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="sobre" className="bg-[#0B0F1A] py-28 md:py-36">
      <div ref={ref} className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Section label */}
        <div
          className={`mb-12 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
        >
          <span className="font-['JetBrains_Mono'] text-[10px] tracking-[0.22em] uppercase text-[#D4A853] block mb-5">
            {t('about_label')}
          </span>
          <h2 className="font-['Instrument_Serif'] text-4xl md:text-5xl text-white leading-tight">
            {t('about_title')}
          </h2>
        </div>

        {/* Divider */}
        <div className="w-full h-px bg-[rgba(247,245,240,0.07)] mb-14" />

        {/* Content */}
        <div
          className={`flex flex-col lg:flex-row items-start gap-12 lg:gap-20 transition-all duration-700 delay-150 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          {/* Left — avatar + name */}
          <div className="flex flex-col items-start gap-6 flex-shrink-0">
            <div className="w-32 h-32 rounded-full border-2 border-[#D4A853] overflow-hidden">
              <img
                src="https://storage.readdy-site.link/project_files/b2da5f54-bd0d-457f-a912-2ea2818e9859/37d85ea7-9102-49f1-8069-3a927bf776e3_ejecutivo.png?v=4701f021dae8b09b2ee0257c763c827d"
                alt="Eduardo Roman"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div>
              <p className="font-['Instrument_Serif'] text-2xl text-white leading-tight mb-1">
                Eduardo Roman
              </p>
              <p className="font-['JetBrains_Mono'] text-[10px] tracking-[0.2em] uppercase text-[#D4A853]">
                {t('about_role')}
              </p>
            </div>
          </div>

          {/* Right — bio */}
          <div className="flex-1 max-w-2xl">
            <p className="font-['DM_Sans'] text-[#6B7280] text-base leading-relaxed mb-6">
              {t('about_bio1')}
            </p>
            <p className="font-['DM_Sans'] text-[#6B7280]/70 text-sm leading-relaxed">
              {t('about_bio2')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
